"use client";

import React, { useState } from "react";
import { program_trainer } from "@/constants";
import { SectionContainerLight } from "../common/sections/SectionContainerLight";
import ProfileTrainerModal from "./ProfileTrainerDetailModal";
import { HeaderSection } from "../common/headers/HeaderSection";
import { ProgramTrainer } from "@/interfaces/ProgramTrainer";

const ProfileTrainer = () => {
  const [selectedTrainer, setSelectedTrainer] = useState<ProgramTrainer | null>(null);
  const [zoomImage, setZoomImage] = useState<string | null>(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  const [title] = useState("Profile Trainer Berkompetensi BNSP");
  //const [subtitle] = useState("Pilihlah Trainer Sesuai Tujuanmu");

  const prevCard = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const nextCard = () => {
    if (currentIndex < program_trainer.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const currentTrainer = program_trainer[currentIndex] ?? null;

  if (!currentTrainer) return null;


  return (
    <SectionContainerLight
      id="profile-trainer"
      additionalClassName="px-4 md:px-12 py-4 sm:-my-[5rem] -my-[1rem] -mt-[1.5rem]"
    >
      <div className="flex flex-col mx-auto text-center mb-2 ">
        <HeaderSection title={title} subtitle="" />
      </div>

      <div className="relative mx-auto max-w-[1080px]">

        <div className="block md:hidden relative">
          {currentIndex > 0 && (
            <button
              onClick={prevCard}
              className="absolute -left-3 top-1/2 -translate-y-1/2 z-20 bg-teal-600 p-2 rounded-full shadow-xl"
            >
              <img src="/img/lms/left-arrow.png" className="w-5" alt="left arrow" />
            </button>
          )}

          <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col">
            <div className="w-full relative">
              <img
                src={currentTrainer?.trainerImageSrc}
                alt={currentTrainer?.fullName}
                className="w-full h-auto object-contain max-h-[300px] mx-auto"
                onClick={() => setZoomImage(currentTrainer.trainerImageSrc)}
              />
            </div>


            <div className="p-4 flex flex-col flex-1">
              <h3 className="font-bold text-lg">
                {currentTrainer?.fullName}
              </h3>
              <p className="text-teal-700 text-sm font-semibold mt-1 mb-4">
                {currentTrainer?.title}
              </p>
              <button
                onClick={() => setSelectedTrainer(currentTrainer)}
                className="bg-teal-600 text-white px-4 py-1 rounded mt-auto self-start font-bold text-xs"
              >
                Lihat Detail
              </button>
            </div>
          </div>

          {currentIndex < program_trainer.length - 1 && (
            <button
              onClick={nextCard}
              className="absolute -right-3 top-1/2 -translate-y-1/2 z-20 bg-teal-600 p-2 rounded-full shadow-xl"
            >
              <img src="/img/lms/right-arrow.png" className="w-5" alt="right arrow" />
            </button>
          )}
        </div>

        <div className="hidden md:grid grid-cols-4 gap-5">
          {program_trainer.map((trainer, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col border"
            >
              <div className="w-full h-[350px] overflow-hidden">
                <img
                  src={trainer.trainerImageSrc}
                  alt={trainer.fullName}
                  className="w-full h-full object-cover cursor-zoom-in"
                  onClick={() => setZoomImage(trainer.trainerImageSrc)}
                />
              </div>

              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-bold text-sm line-clamp-2 ">
                  {trainer.fullName}
                </h3>
                <p className="text-teal-700 text-xs font-semibold mt-1">
                  {trainer.title}
                </p>

                <button
                  onClick={() => setSelectedTrainer(trainer)}
                  className="bg-teal-600 text-white px-4 py-1 rounded mt-auto self-end font-bold"
                >
                  Lihat Detail
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {zoomImage && (
        <div
          onClick={() => setZoomImage(null)}
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[999] p-4"
        >
          <div onClick={(e) => e.stopPropagation()} className="relative">
            <button
              onClick={() => setZoomImage(null)}
              className="absolute -top-4 -right-4 w-10 h-10 bg-white rounded-full text-3xl font-bold text-gray-700 hover:text-gray-200 shadow"
            >
              &times;
            </button>

            <img
              src={zoomImage}
              alt="Trainer Preview"
              className="max-w-full max-h-[90vh] rounded-lg shadow-2xl"
            />
          </div>
        </div>
      )}

      {selectedTrainer && (
        <ProfileTrainerModal
          trainer={selectedTrainer}
          onClose={() => setSelectedTrainer(null)}
        />
      )}
    </SectionContainerLight>
  );
};

export default ProfileTrainer;
